
/* 
This util function accepts html tags (via 'html' param) and converts them into custom html code
default values for minimal usage:

    fontSize = 16, color = "white", fontWeight=200 , textAlign= "left"

usage: 
    HtmlWrapper("Sample Text!"); // plain text
    HtmlWrapper("Sample Text!",  20, 300, "red" , "center"); // with styles
*/

import ReactHtmlParser from 'react-html-parser';

export const HtmlWrapper = (html) => {
    if (!html) return "";
    let _html = html;
    return ReactHtmlParser(_html);
}

export const fontStyles = {
    title: {
        fontSize: 24,
        fontWeight: 500
    },
    subTitle: {
        fontSize: 22,
        fontWeight: 100
    },
    itemTitle: {
        fontSize: 22,
        fontWeight: 100
    },
    itemDesc: {
        fontSize: 18,
        fontWeight: 100
    },
    notice: {
        fontSize: 18,
        fontWeight: 100
    },
    tiny: {
        fontSize: 14,
        fontWeight: 100
    },
    caption: {
        fontSize: 28,
        fontWeight: 600
    },
}



// WEBPACK FOOTER //
// ./src/Utils.js